/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerCreatedBy } from './org-monthly-card-transaction-merged-transaction-detail-list-inner-evidence-list-inner-created-by';
// May contain unused imports in some cases
// @ts-ignore
import { OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrors } from './org-monthly-card-transaction-merged-transaction-detail-list-inner-evidence-list-inner-errors';
// May contain unused imports in some cases
// @ts-ignore
import { OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer } from './org-monthly-card-transaction-merged-transaction-detail-list-inner-evidence-list-inner-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy } from './org-monthly-card-transaction-merged-transaction-detail-list-inner-evidence-list-inner-updated-by';
// May contain unused imports in some cases
// @ts-ignore
import { OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerUploadedBy } from './org-monthly-card-transaction-merged-transaction-detail-list-inner-evidence-list-inner-uploaded-by';
// May contain unused imports in some cases
// @ts-ignore
import { OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarnings } from './org-monthly-card-transaction-merged-transaction-detail-list-inner-evidence-list-inner-warnings';

/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner {
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'cardTransactionEvidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'paymentType': OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'electronicMethod': OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'documentSize': OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'dpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'legalValidity': OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'invoiceIssuer': OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer | null;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'dpiError': OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'detectedDpiError': OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'calculatedDpiError': OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'colorGradationError': OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'heightMillisError': OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'widthMillisError': OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum;
    /**
     * 
     * @type {OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrors}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'errors': OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrors;
    /**
     * 
     * @type {OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarnings}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'warnings': OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarnings;
    /**
     * 
     * @type {OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerCreatedBy}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'createdBy': OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerCreatedBy;
    /**
     * 
     * @type {OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'updatedBy': OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerUploadedBy}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedBy': OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'needsMigration': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedFrom': string;
}

export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum];
export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum];
export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum];
export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum];
export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum];
export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum];
export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum];
export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum];
export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum];
export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum];


